interface StoreLocationMapProps {
  lat: number;
  lng: number;
  address: string;
  className?: string;
}

function mapsSearchUrl(lat: number, lng: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

function mapsSearchByAddressUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

function openStreetMapEmbedUrl(lat: number, lng: number): string {
  const delta = 0.012;
  const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(',');
  return `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(bbox)}&layer=mapnik&marker=${lat}%2C${lng}`;
}

export function StoreLocationMap({ lat, lng, address, className }: StoreLocationMapProps) {
  return (
    <div className={className}>
      <iframe
        title={`Map for ${address}`}
        src={openStreetMapEmbedUrl(lat, lng)}
        className="w-full h-40 rounded-lg border border-gray-200"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <p className="text-sm text-gray-600 mt-2">{address}</p>
      <p className="text-xs text-gray-400 mt-1">
        {lat.toFixed(5)}, {lng.toFixed(5)}
      </p>
      <a
        href={mapsSearchUrl(lat, lng)}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-blue-600 hover:underline mt-1 inline-block"
      >
        Open in Google Maps
      </a>
    </div>
  );
}

export function StoreLocationFallback({ address, className }: { address: string; className?: string }) {
  return (
    <div className={className}>
      <div className="w-full h-40 rounded-lg border border-dashed border-gray-300 bg-gray-50 flex items-center justify-center text-sm text-gray-500 px-4 text-center">
        No map coordinates on the store record yet.
      </div>
      <p className="text-sm text-gray-600 mt-2">{address}</p>
      <a
        href={mapsSearchByAddressUrl(address)}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-blue-600 hover:underline mt-1 inline-block"
      >
        Search address in Google Maps
      </a>
    </div>
  );
}
